/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericModalComponent} from './generic-modal.component';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [GenericModalComponent],
    exports: [
        GenericModalComponent
    ],
    imports: [
        CommonModule,
        LoadingSpinnerModule
    ]
})
export class GenericModalModule {
}
